module.exports = __webpack_public_path__ + "static/media/personalization-present-banner-02.c0eb15d1.png";